// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectBrandingRulesMessage } from '@shared/utils/DirectMessages/DirectMessagesImport';
import { MessageProcessorBase } from './MessageProcessorBase';
import { FieldsFactory } from '../Factory/FieldsFactory';
const UNAVAILABLE_BRANDING_RULE_VALUE = '<UNAVAILABLE>';
export class BrandingRulesMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const message = new DirectBrandingRulesMessage();
        const groups = fieldSet.GetGroups(FieldsFactory.KEY_VALUE_GROUP);
        const len = groups.length;
        for (let i = 0; i < len; i++) {
            const ruleValue = groups[i].GetValue(FieldsFactory.FIELD_VALUE);
            const ruleName = groups[i].GetValue(FieldsFactory.FIELD_KEY);
            if (ruleValue === UNAVAILABLE_BRANDING_RULE_VALUE) {
                continue;
            }
            switch (ruleName) {
                case 'BRANDING_TOOLS': {
                    message.Tools = ruleValue;
                    break;
                }
                case 'BRANDING_COMPANY_NAME': {
                    message.CompanyName = ruleValue;
                    break;
                }
                case 'BRANDING_COMPANY_URL': {
                    message.CompanyURL = ruleValue;
                    break;
                }
                case 'BRANDING_BROKER_INFORMATION': {
                    message.BrokerInformation = ruleValue;
                    break;
                }
                case 'BRANDING_POWERED_BY_NAME': {
                    message.PoweredByName = ruleValue;
                    break;
                }
                case 'BRANDING_POWERED_BY_URL': {
                    message.PoweredByURL = ruleValue;
                    break;
                    /* edited in #125345: */
                }
                case 'BRANDING_DEMOREGISTRATION_URL':
                case 'BRANDING_LOGIN_URL': {
                    /* URLs of Login screen demoreg link 1(=left),2(=right) */
                    message.BrandingDemoregistrationURLs.push(ruleValue);
                    break;
                }
                case 'BRANDING_DEMOREGISTRATION_URL_NAME':
                case 'BRANDING_LOGIN_URL_NAME': {
                    /* labels' text of Login screen demoreg link 1(=left),2(=right)  */
                    let linkName = ruleValue;
                    if (ruleName === 'BRANDING_DEMOREGISTRATION_URL_NAME' && !linkName) {
                        linkName = 'Registration'; // #126100 #126101
                    }
                    message.BrandingDemoregistrationURLNames.push(linkName);
                    break;
                    /* Added in ancient times (B.C.): */
                }
                case 'BRANDING_FORGOTPWD_URL': {
                    message.BrandingForgotpwdURL = ruleValue;
                    break;
                }
                case 'BRANDING_VISIBLE_INSTRUMENT_LOGO': {
                    message.BrandingVisibleInstrumentLogo = ruleValue;
                    break;
                }
                case 'BRANDING_SERVER_URL': {
                    message.BrandingServerURL = ruleValue;
                    break;
                }
                case 'BRANDING_IP_SERVICE_URL': {
                    message.BrandingIpServicesURL = ruleValue;
                    break;
                    /* added in #115286 Web: */
                }
                case 'BRANDING_WEB_NAME': {
                    message.BrandingWebName = ruleValue;
                    break;
                }
                case 'BRANDING_WEB_LOGIN_BANNER': {
                    message.BrandingWebLoginBanner = ruleValue;
                    break;
                }
                case 'BRANDING_WEB_SPLASH_SCREEN': {
                    message.BrandingWebSplashScreen = ruleValue;
                    break;
                }
                case 'BRANDING_WEB_HEADER': {
                    message.BrandingWebHeader = ruleValue;
                    break;
                }
                case 'BRANDING_WEB_FAVICON': {
                    message.BrandingWebFavicon = ruleValue;
                    break;
                    /* FROM .Net Light Theme added in #126603 Web: */
                }
                case 'BRANDING_NET_RIBBONICON_LIGHT': {
                    message.BrandingWebHeaderLightTheme = ruleValue;
                    break;
                }
                case 'BRANDING_NET_LOGO_LIGHT': {
                    message.BrandingWebLoginBannerLightTheme = ruleValue;
                    break;
                    /* added in #119719 Web: */
                }
                case 'BRANDING_EXTERNAL_AUTHENTICATION': {
                    message.BrandingExternalAuthenticationType = ruleValue;
                    break;
                }
                case 'BRANDING_EXTERNAL_AUTHENTICATION_URL': {
                    message.BrandingExternalAuthenticationUrl = ruleValue;
                    break;
                }
                case 'BRANDING_EXTERNAL_AUTHENTICATION_WEB_CLIENTID': {
                    message.BrandingExternalAuthenticationWebClientId = ruleValue;
                    break;
                }
                case 'BRANDING_EXTERNAL_AUTHENTICATION_WEBMOBILE_CLIENTID': {
                    message.BrandingExternalAuthenticationWebMobileClientId = ruleValue;
                    break;
                }
                case 'BRANDING_EXTERNAL_AUTHENTICATION_LOGOUT_URL': {
                    message.BrandingExternalAuthenticationLogoutUrl = ruleValue;
                    break;
                }
                case 'BRANDING_ALLOW_PASSWORD_PREVIEW': {
                    message.BrandingAllowPasswordPreview = ruleValue;
                    break;
                }
                case 'BRANDING_ALLOW_SAVE_PASSWORD': {
                    message.BrandingAllowSavePassword = ruleValue;
                    break;
                }
                case 'BRANDING_LOGIN_PROMPT_TEXT': {
                    message.BrandingLoginPromptText = ruleValue;
                    break;
                }
                // #region #115286 Web Mobile:
                case 'BRANDING_MOBILE_ACTIVE_WEB_LOGIN_BANNER': {
                    message.BrandingWMLoginBanner = ruleValue;
                    break;
                }
                case 'BRANDING_MOBILE_WEB_ACTIVE_BACKGROUND_IMAGE': {
                    message.BrandingWMBackgroundImage = ruleValue;
                    break;
                }
                case 'BRANDING_MOBILE_ACTIVE_WEB_FAVICON': {
                    message.BrandingWMFavicon = ruleValue;
                    break;
                }
                // #region Localizations:
                case 'BRANDING_WEB_LANG_FILE': {
                    message.BrandingWebLangFiles = ruleValue;
                    break;
                }
                case 'BRANDING_WEB_CUSTOM_URL': {
                    message.BrandingWebCustomUrl = ruleValue;
                    break;
                }
                case 'BRANDING_TV_LOGO': {
                    message.BrandingTVLogo = ruleValue;
                    break;
                }
                case 'BRANDING_TV_FAVICON': {
                    message.BrandingTVFavicon = ruleValue;
                    break;
                }
                case 'BRANDING_TV_NAME': {
                    message.BrandingTVName = ruleValue;
                    break;
                }
                case 'BRANDING_WEBHOOK_URL':
                    message.BrandingWebhookURL = ruleValue;
                    break;
                case 'BRANDING_WEBHOOK_HELP_URL':
                    message.BrandingWebhookHelpURL = ruleValue;
                    break;
                //#region PWA mainifest:
                case 'BRANDING_PWA_APP_NAME':
                    message.BrandingPwaAppName = ruleValue;
                    break;
                case 'BRANDING_PWA_SHORT_APP_NAME':
                    message.BrandingPwaShortAppName = ruleValue;
                    break;
                case 'BRANDING_PWA_DESCRIPTION':
                    message.BrandingPwaDescription = ruleValue;
                    break;
                case 'BRANDING_MOBILE_WEB_ICON_32':
                    message.BrandingMobileWebIcon32 = ruleValue;
                    break;
                case 'BRANDING_MOBILE_WEB_ICON_32_HASH':
                    message.BrandingMobileWebIconHash32 = ruleValue;
                    break;
                case 'BRANDING_MOBILE_WEB_ICON_48':
                    message.BrandingMobileWebIcon48 = ruleValue;
                    break;
                case 'BRANDING_MOBILE_WEB_ICON_48_HASH':
                    message.BrandingMobileWebIconHash48 = ruleValue;
                    break;
                case 'BRANDING_MOBILE_WEB_ICON_72':
                    message.BrandingMobileWebIcon72 = ruleValue;
                    break;
                case 'BRANDING_MOBILE_WEB_ICON_72_HASH':
                    message.BrandingMobileWebIconHash72 = ruleValue;
                    break;
                case 'BRANDING_MOBILE_WEB_ICON_96':
                    message.BrandingMobileWebIcon96 = ruleValue;
                    break;
                case 'BRANDING_MOBILE_WEB_ICON_96_HASH':
                    message.BrandingMobileWebIconHash96 = ruleValue;
                    break;
                case 'BRANDING_MOBILE_WEB_ICON_128':
                    message.BrandingMobileWebIcon128 = ruleValue;
                    break;
                case 'BRANDING_MOBILE_WEB_ICON_128_HASH':
                    message.BrandingMobileWebIconHash128 = ruleValue;
                    break;
                case 'BRANDING_MOBILE_WEB_ICON_256':
                    message.BrandingMobileWebIcon256 = ruleValue;
                    break;
                case 'BRANDING_MOBILE_WEB_ICON_256_HASH':
                    message.BrandingMobileWebIconHash256 = ruleValue;
                    break;
                case 'BRANDING_MOBILE_WEB_ICON_512':
                    message.BrandingMobileWebIcon512 = ruleValue;
                    break;
                case 'BRANDING_MOBILE_WEB_ICON_512_HASH':
                    message.BrandingMobileWebIconHash512 = ruleValue;
                    break;
                // #endregion
            }
        }
        return [message];
    }
}
